import { render, staticRenderFns } from "./CategoryGroups.vue?vue&type=template&id=23266854"
import script from "./CategoryGroups.js?vue&type=script&lang=js&external"
export * from "./CategoryGroups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports